import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=053569f6&scoped=true"
import script from "./password-reset.vue?vue&type=script&lang=js"
export * from "./password-reset.vue?vue&type=script&lang=js"
import style0 from "./password-reset.vue?vue&type=style&index=0&id=053569f6&prod&lang=scss"
import style1 from "./password-reset.vue?vue&type=style&index=1&id=053569f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053569f6",
  null
  
)

export default component.exports